import React from "react";
import "../../assets/css/order-summary.css";

type OrderSummaryProps = {
  children?: React.ReactNode;
  visible: boolean;
};

export function OrderSummary(props: OrderSummaryProps) {
  const { children, visible = false } = props;
  const style = visible ? { border: "none" } : { display: "none" };

  return (
    <div className="order-summary" style={style}>
      <div className="order-summary__wrapper">
        <div className="order-summary__contents">{children}</div>
      </div>
    </div>
  );
}

export default OrderSummary;
